import { Role } from './role';

export class User {
  id: number;
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  // The API returns these fields for dashboard users.
  name?: string;
  image?: string;
  avatar: string;
  role: Role;
  token?: string;
}
